import { render, staticRenderFns } from "./notificacionesWeb.vue?vue&type=template&id=324a147f&"
import script from "./notificacionesWeb.vue?vue&type=script&lang=js&"
export * from "./notificacionesWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports